import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Triangle } from "lucide-react";

const RiskScoring = () => {
  const [vulns, setVulns] = useState([]);
  useEffect(() => { api.get("/vulnerabilities").then(({ data }) => setVulns(data)); }, []);

  const buckets = { critical: [], high: [], medium: [], low: [] };
  vulns.forEach((v) => buckets[v.severity]?.push(v));

  return (
    <div className="p-6 max-w-7xl">
      <PageHeader
        tag="Governance / Risk"
        title="Risk Scoring"
        subtitle="Vulnerability prioritization with CVSS, exploit weaponization, and asset criticality factors."
      />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        {[
          ["critical", "rose"],
          ["high", "amber"],
          ["medium", "cyan"],
          ["low", "slate"],
        ].map(([sev, col]) => (
          <div key={sev} className="csx-card p-4">
            <div className={`font-display text-4xl font-black text-${col}-400`}>{buckets[sev].length}</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-400 mt-1">{sev}</div>
          </div>
        ))}
      </div>

      <div className="csx-card p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-widest text-slate-500 border-b border-slate-800 bg-slate-950/60">
              <th className="py-2.5 px-4">CVE</th>
              <th className="px-4">Title</th>
              <th className="px-4">Asset</th>
              <th className="px-4">CVSS</th>
              <th className="px-4">Severity</th>
              <th className="px-4">Exploitable</th>
              <th className="px-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {vulns.map((v) => {
              const c = v.severity === "critical" ? "rose" : v.severity === "high" ? "amber" : v.severity === "medium" ? "cyan" : "slate";
              return (
                <tr key={v.id} className="border-b border-slate-900 hover:bg-slate-900/40">
                  <td className="py-2.5 px-4 font-mono text-cyan-300">{v.cve}</td>
                  <td className="px-4 text-slate-200">{v.title}</td>
                  <td className="px-4 text-slate-400 font-mono">{v.asset}</td>
                  <td className="px-4 font-mono text-fuchsia-300">{v.cvss}</td>
                  <td className="px-4">
                    <span className={`text-[10px] uppercase tracking-widest border border-${c}-500/60 text-${c}-300 bg-${c}-500/10 px-1.5 py-0.5`}>
                      {v.severity}
                    </span>
                  </td>
                  <td className="px-4">
                    {v.exploitable ? (
                      <span className="flex items-center gap-1 text-rose-300 text-xs">
                        <Triangle className="h-3 w-3 fill-rose-400" /> Weaponized
                      </span>
                    ) : <span className="text-slate-500 text-xs">No PoC</span>}
                  </td>
                  <td className="px-4 text-slate-400 text-xs uppercase tracking-widest">{v.status.replace(/_/g, " ")}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RiskScoring;
